export const WERKZEUGVERWALTUNG = 'werkzeugverwaltung';
export const MESSMITTELVERWALTUNG = 'messmittelverwaltung';
export const WERKZEUGVERWALTUNG_HISTORIE = 'werkzeugverwaltung/historie';
export const WERKZEUGVERWALTUNG_ABMUSTERUNG = 'werkzeugverwaltung/abmusterung';

export const MESSMITTELVERWALTUNGG_HISTORIE = 'messmittelverwaltung/historie';
export const SESSION = 'session';
export const PROZESSKONTROLLKARTE = 'prozesskontrollkarte';
export const ABMUSTERUNG = 'abmusterung';
